<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <v-card class="card-body">
        <v-container>
          <h5>Anrede</h5>

          <v-text-field
            id="anredeInputDE"
            v-model="anredenObject.anrede_de"
            label="Deutsch"
          />
          <v-text-field
            id="anredeInputFR"
            v-model="anredenObject.anrede_fr"
            label="Französisch"
          />
          <v-text-field
            id="anredeInputIT"
            v-model="anredenObject.anrede_it"
            label="Italienisch"
          />
        </v-container>
      </v-card>

      <v-card class="card-body">
        <v-container>
          <h5>Briefanrede</h5>

          <v-text-field
            id="briefanredeInputDE"
            v-model="anredenObject.briefanrede_de"
            label="Deutsch"
          />
          <v-text-field
            id="briefanredeInputFR"
            v-model="anredenObject.briefanrede_fr"
            label="Französisch"
          />
          <v-text-field
            id="briefanredeInputIT"
            v-model="anredenObject.briefanrede_it"
            label="Italienisch"
          />
        </v-container>
      </v-card>
      <v-btn
        :disabled="
          !anredenObject.anrede_de ||
            !anredenObject.anrede_fr ||
            !anredenObject.anrede_fr ||
            !anredenObject.briefanrede_de ||
            !anredenObject.briefanrede_fr ||
            !anredenObject.briefanrede_it
        "
        class="btn-left"
        color="success"
        raised
        title="Neue Anrede erfassen"
        @click="createNewAnrede"
      >
        <i class="fas fa-plus mr-3" /> Neu Erfassen
      </v-btn>

      <v-btn
        color="#e72b37"
        raised
        style="color: white"
        title="Erfassen Abbrechen"
        @click="cancelCreate"
      >
        <i class="fas fa-ban mr-3" /> Abbrechen
      </v-btn>
    </div>
  </div>
</template>

<script>
import { PostFormOfAddress } from "@/services/user.crm.service";

export default {
  data() {
    return {
      isLoading: false,
      anredenObject: {
        anrede_de: "",
        anrede_fr: "",
        anrede_it: "",
        briefanrede_de: "",
        briefanrede_fr: "",
        briefanrede_it: "",
      },
      errorObject: null,
    };
  },
  methods: {
    resetAnredenObject() {
      for (var member in this.anredenObject) delete this.anredenObject[member];
    },
    routePage() {
      if (this.$route.query.createContact) {
        this.$router.push({
          path: "/contacts/create",
        });
      } else if (this.$route.query.editContact) {
        this.$router.push({
          path: "/contacts/edit?contact=" + this.$route.query.editContact,
        });
      } else {
        this.$router.push({
          path: "/anrede",
        });
      }
    },
    cancelCreate() {
      this.resetAnredenObject();
      this.routePage();
    },
    createNewAnrede() {
      this.isLoading = true;
      const newAnredenObject = {
        id: 0,
        code: this.anredenObject.anrede_de,
        formOfAddressContents: [
          {
            id: 0,
            formOfAddressId: 0,
            value: this.anredenObject.anrede_de,
            letterFormOfAddress: this.anredenObject.briefanrede_de,
            language: "de-CH",
          },
          {
            id: 0,
            formOfAddressId: 0,
            value: this.anredenObject.anrede_fr,
            letterFormOfAddress: this.anredenObject.briefanrede_fr,
            language: "fr-CH",
          },
          {
            id: 0,
            formOfAddressId: 0,
            value: this.anredenObject.anrede_it,
            letterFormOfAddress: this.anredenObject.briefanrede_it,
            language: "it-CH",
          },
        ],
      };

      PostFormOfAddress(
        newAnredenObject,
        () => {
          this.resetAnredenObject();
          this.isLoading = false;

          this.routePage();
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style scoped>
.card-body {
  margin-top: 20px;

  margin-bottom: 20px;

  margin-left: 20px;
  width: 600px !important;
}

.btn-left {
  margin-left: 20px;
}
</style>
